mutation DeleteNewsletter($id: ID!) {
    campaignDelete(input: {id: $id}) {
        campaign {
            id
        }
    }
}
